import { Tabs } from "antd";
import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// Custom styles - horizontal scroll only on small screens, full width layout on larger screens
const customTabStyles = `
  /* Hide the overflow "..." menu on all screens */
  .custom-scrollable-tabs .ant-tabs-nav-operations {
    display: none !important;
  }
  .custom-scrollable-tabs .ant-tabs-nav-more {
    display: none !important;
  }
  .custom-scrollable-tabs .ant-tabs-nav-wrap::before,
  .custom-scrollable-tabs .ant-tabs-nav-wrap::after {
    display: none !important;
  }
  
  /* Mobile: enable horizontal scroll */
  @media (max-width: 768px) {
    .custom-scrollable-tabs .ant-tabs-nav-wrap {
      overflow-x: auto !important;
      overflow-y: hidden !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
    }
    .custom-scrollable-tabs .ant-tabs-nav-wrap::-webkit-scrollbar {
      display: none !important;
    }
    .custom-scrollable-tabs .ant-tabs-nav-list {
      flex-wrap: nowrap !important;
    }
    .custom-scrollable-tabs .ant-tabs-tab {
      flex-shrink: 0 !important;
      white-space: nowrap !important;
    }
  }
`;

export default function CustomTabs({ items }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab") || "1";
  const [activeKey, setActiveKey] = useState(tabFromUrl);

  useEffect(() => {
    // Only update if different to prevent loops
    if (tabFromUrl !== activeKey) {
      setActiveKey(tabFromUrl);
    }
  }, [tabFromUrl, activeKey]);

  const handleTabChange = useCallback((key) => {
    if (key !== activeKey) {
      setActiveKey(key);
      setSearchParams({ tab: key }, { replace: true });
    }
  }, [activeKey, setSearchParams]);

  return (
    <div className="w-full">
      <style>{customTabStyles}</style>
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        moreIcon={null}
        items={items.map((item) => ({
          ...item,
          label: (
            <span
              className={`text-base font-semibold transition-colors duration-200 ${activeKey === item.key ? "text-[var(--color-primary)]" : "text-gray-600"
                }`}
            >
              {item.label}
            </span>
          ),
        }))}
        className="
          custom-scrollable-tabs
          [&_.ant-tabs-nav]:bg-white 
          [&_.ant-tabs-nav]:rounded-md
          [&_.ant-tabs-nav]:px-4
          [&_.ant-tabs-nav-list]:w-full 
          [&_.ant-tabs-nav-list]:justify-between 
          [&_.ant-tabs-tab]:flex-1 
          [&_.ant-tabs-tab]:justify-center 
          [&_.ant-tabs-ink-bar]:!bg-[var(--color-primary)] 
          [&_.ant-tabs-ink-bar]:!h-[4px] 
          [&_.ant-tabs-ink-bar]:!rounded-md
          [&_.ant-tabs-ink-bar]:!w-[10%] 
          [&_.ant-tabs-nav]:border-b-0
        "
      />
    </div>
  );
}